<template>
    <button class="btn" @click.prevent="store.unblock(user)">{{word.unblock}}</button>
</template>

<script>
    import store from '../../../front/components/messenger-store'

    export default {
        name: "unblock-button",

        props: {
            user: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                word: window.word,
                text: window.text,
            }
        },
        created() {
            this.store = store
        }
    }
</script>
